import { getSessionStorageItemJson } from '@vfde-sails/storage';
import { SailsStoneDdpStorage } from 'Container/App/interface';
import {
    ADDITIONAL_PAGE_OPTIONS,
    SAILS_MULTICARD_STORAGE,
    SAILS_PARAM_HARDWAREONLY,
} from '@vfde-sails/constants';
import { APP } from 'Constant';
import { CONTAINER } from 'Container/App/constants';

/**
 * Get hardware only
 */
export const getHardwareOnly = (storage?: SailsStoneDdpStorage | null): boolean | undefined => {
    storage = storage || getSessionStorageItemJson<SailsStoneDdpStorage | null>(SAILS_MULTICARD_STORAGE);
    const deviceId = window[ADDITIONAL_PAGE_OPTIONS].deviceId;

    const mainStorage = storage?.[SAILS_PARAM_HARDWAREONLY];
    const deviceStorage = storage?.[APP]?.[CONTAINER]?.[deviceId]?.[SAILS_PARAM_HARDWAREONLY];

    if (mainStorage === false) {
        return false;
    }

    return deviceStorage;
};
